// video-carousel-lightbox.reels.final.js
// Full replacement file - optimized + cart drawer refresh logic
// Drop into your theme replacing previous reelrush JS
(function () {
  if (window.__vcInitialized) {
    console.warn("[VC] already initialized - abort");
    return;
  }

  // Safety: global error capture to avoid site break
  window.addEventListener("error", (e) =>
    console.error("[VC global error]", e.error || e.message)
  );
  window.addEventListener("unhandledrejection", (e) =>
    console.error("[VC unhandledrejection]", e.reason)
  );

  // ---------- Config / prioritized candidates ----------
  const DRAWER_SELECTORS = [
    ".quick-cart__wrapper",
    "#quick-cart",
    ".cart-drawer",
    "#CartDrawer",
    ".mini-cart",
    "#mini-cart",
    ".ajax-cart",
    ".cart-notification",
    ".quick-cart",
    ".drawer--cart",
  ];
  // Likely section IDs used by themes. Add theme-specific IDs here if needed.
  const SECTION_CANDIDATES = [
    "quick-cart",
    "cart-drawer",
    "mini-cart",
    "ajax-cart",
    "cart-notification",
    "cart",
  ];

  // ---------- Util functions ----------
  const $ = (s) => document.querySelector(s);
  const $$ = (s) => Array.from(document.querySelectorAll(s));
  const safeText = (s) => (s || "").toString().trim();

  // ---------- Cart helpers (NEW) ----------
  async function updateCartCountFromServer() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) throw new Error("Failed to fetch /cart.js");
      const cart = await res.json();
      const count = cart.item_count || 0;
      document.querySelectorAll(".cart-count").forEach((el) => {
        el.textContent = count;
      });
      console.log("[VC] cart count updated ->", count);
      // dispatch event so theme/apps can react
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      return cart;
    } catch (err) {
      console.error("[VC] updateCartCountFromServer error:", err);
      return null;
    }
  }

  // Try to find an actual visible drawer container on the page
  function detectDrawerContainer() {
    for (const sel of DRAWER_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) {
        console.log("[VC] detected drawer container:", sel);
        return el;
      }
    }
    console.warn("[VC] no drawer container detected from known selectors");
    return null;
  }

  // Replace inner HTML of the drawer container with the fetched section HTML
  function replaceDrawerHtml(drawerEl, html) {
    if (!drawerEl || !html) return false;
    // Basic sanitization: ensure html is string
    try {
      drawerEl.innerHTML = html;
      console.log("[VC] replaced drawer HTML for", drawerEl);
      return true;
    } catch (err) {
      console.warn("[VC] failed to replace drawer HTML", err);
      return false;
    }
  }

  // Attempt to open the drawer by adding common 'active' classes or firing events
  function openDrawerUI(drawerEl) {
    if (!drawerEl) return;
    // Common patterns
    try {
      // Add 'active' if present
      drawerEl.classList.add("active");
      // If the drawer has overlay sibling, try opening it
      const overlay = document.querySelector(".quick-cart__overlay") || document.querySelector(".cart-drawer__overlay");
      if (overlay) {
        overlay.style.opacity = "1";
        overlay.classList && overlay.classList.add("active");
      }
      // Dispatch events for theme compatibility
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.dispatchEvent(new CustomEvent("cart:drawer:open"));
      console.log("[VC] attempted to open drawer UI");
    } catch (err) {
      console.warn("[VC] openDrawerUI error:", err);
    }
  }

  // Best-effort: fetch section HTML for a given sectionId
  async function fetchSectionHtml(sectionId) {
    try {
      const url = `/?section_id=${encodeURIComponent(sectionId)}`;
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) {
        // not found or server error
        return null;
      }
      const text = await res.text();
      if (!text || text.length < 30) return null;
      return text;
    } catch (err) {
      console.warn("[VC] fetchSectionHtml error for", sectionId, err);
      return null;
    }
  }

  // Try to refresh the cart drawer:
  // 1. detect drawer element in DOM
  // 2. try common section IDs and inject returned HTML
  // 3. open drawer and dispatch events
  async function refreshCartDrawer(cartData = null) {
    try {
      const drawerEl = detectDrawerContainer();
      if (!drawerEl) {
        console.warn("[VC] refreshCartDrawer: no drawer container; skipping HTML refresh");
        return false;
      }

      // Try to use a configured section id if the theme provided one via data attribute
      const configured = drawerEl.dataset && drawerEl.dataset.sectionId;
      if (configured) {
        const html = await fetchSectionHtml(configured);
        if (html) {
          replaceDrawerHtml(drawerEl, html);
          openDrawerUI(drawerEl);
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart", { detail: cartData || null}));
          return true;
        }
      }

      // Otherwise, iterate through candidates
      for (const sectionId of SECTION_CANDIDATES) {
        const html = await fetchSectionHtml(sectionId);
        if (html) {
          // Found a valid fragment — put it into detected container
          replaceDrawerHtml(drawerEl, html);
          openDrawerUI(drawerEl);
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart", { detail: cartData || null}));
          console.log("[VC] refreshCartDrawer used section:", sectionId);
          return true;
        }
      }

      // As a fallback, try fetching the cart drawer endpoint /cart (some themes include fragments)
      try {
        const alt = await fetch("/cart", { credentials: "same-origin" });
        if (alt.ok) {
          const html = await alt.text();
          if (html && html.length > 100) {
            replaceDrawerHtml(drawerEl, html);
            openDrawerUI(drawerEl);
            document.dispatchEvent(new CustomEvent("apps:product-added-to-cart", { detail: cartData || null}));
            console.log("[VC] refreshCartDrawer fallback used /cart");
            return true;
          }
        }
      } catch (e) {
        // ignore
      }

      console.warn("[VC] refreshCartDrawer: no section candidates returned useful HTML");
      return false;
    } catch (err) {
      console.error("[VC] refreshCartDrawer error:", err);
      return false;
    }
  }

  // ---------- Original video/carousel code (optimized) ----------
  function onLoadOnce() {
    try {
      console.log("[VC] init start");

      const isMobile = window.innerWidth < 768;
      let currentIndex = 0;
      let blockDataMap = []; // { videoSrc, productHTML, poster }
      let mobileVideoSwiper = null;
      let rafId = null;
      let activeVideo = null;
      let mobilePrepared = false;

      // DOM refs (guarded)
      const videoLightbox = $("#universal-video-lightbox");
      const lightboxVideo = $("#lightbox-video");
      const mobileContainer = $(".mobile-video-swiper-container");
      const mobileVideoWrapper = $("#mobile-video-wrapper");
      const lightboxProductsGrid = $("#lightbox-products-grid");
      const drawerProductsGrid = $("#drawer-products-grid");
      const desktopProgressEl = document.querySelector(".lightbox-video-container .video-progress-bar .progress");
      const mobileProgressEl = mobileContainer ? mobileContainer.querySelector(".video-progress-bar .progress") : null;
      const cartNotification = $("#cart-notification");

      // Build blockDataMap from hidden meta container (Liquid output)
      const metaContainer = $(".video-meta-data") || document;
      const dataEls = Array.from(metaContainer.querySelectorAll('[id^="video-data-"]'));
      dataEls.forEach((el) => {
        blockDataMap.push({
          videoSrc: el.getAttribute("data-video-src") || "",
          productHTML: el.innerHTML || "",
          poster: el.getAttribute("data-poster") || el.querySelector("img")?.src || "",
        });
      });
      console.log("[VC] blockDataMap length:", blockDataMap.length);

      // Preload hint helper
      function addPreloadHint(href) {
        try {
          if (!href) return null;
          const existing = document.querySelector(`link[rel="preload"][href="${href}"]`);
          if (existing) return existing;
          const link = document.createElement("link");
          link.rel = "preload";
          link.as = "video";
          link.href = href;
          document.head.appendChild(link);
          return link;
        } catch (err) {
          return null;
        }
      }

      // Mobile placeholder creation (fast)
      function prepareMobileSlidesLazy() {
        if (!mobileVideoWrapper || mobilePrepared) return;
        mobileVideoWrapper.innerHTML = "";

        // Attach drawer handlers (if drawer button exists)
        const drawerHandle = document.getElementById("lightbox-drawer-handle");
        const drawer = document.getElementById("lightbox-drawer");
        const drawerCloseBtn = document.getElementById("drawer-close-btn");
        if (drawerHandle && drawer) {
          drawerHandle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            drawer.classList.toggle("open");
            console.log("[VC] drawer toggled:", drawer.classList.contains("open"));
          });
        }
        if (drawerCloseBtn && drawer) {
          drawerCloseBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            drawer.classList.remove("open");
            console.log("[VC] drawer closed");
          });
        }

        blockDataMap.forEach((b, i) => {
          const slide = document.createElement("div");
          slide.className = "swiper-slide";
          slide.dataset.vcIndex = i;
          const posterStyle = b.poster ? `background-image:url('${b.poster}');background-size:cover;background-position:center;` : "";
          slide.innerHTML = `
            <div class="video-aspect-wrapper" style="height:100%;width:100%;${posterStyle}">
              <video playsinline preload="metadata" muted loop style="width:100%;height:100%;object-fit:cover;display:block;" data-src="${b.videoSrc}"></video>
            </div>
          `;
          mobileVideoWrapper.appendChild(slide);
        });
        mobileVideoWrapper.dataset.vcPrepared = "1";
        mobilePrepared = true;
        sizeMobileSlides();
        console.log("[VC] mobile placeholders prepared:", mobileVideoWrapper.querySelectorAll(".swiper-slide").length);
      }

      // size slides to full viewport height
      function sizeMobileSlides() {
        if (!mobileVideoWrapper) return;
        const h = window.innerHeight;
        mobileVideoWrapper.querySelectorAll(".swiper-slide").forEach((s) => { s.style.height = h + "px"; });
      }
      window.addEventListener("resize", () => sizeMobileSlides());

      // Lazy load strategy
      function ensureVideoLoadedAt(index) {
        if (!mobileVideoWrapper) return false;
        const slide = mobileVideoWrapper.querySelector(`.swiper-slide[data-vc-index="${index}"]`);
        if (!slide) return false;
        const video = slide.querySelector("video");
        if (!video) return false;
        if (video.dataset.loaded === "1") return true;
        const src = video.dataset.src;
        if (!src) return false;
        addPreloadHint(src);
        video.src = src;
        video.setAttribute("preload", "auto");
        try { video.load(); } catch (e) { /* ignore */ }
        video.dataset.loaded = "1";
        console.log("[VC] lazy-loaded video at index", index, src);
        return true;
      }
      function preloadNeighbors(index) {
        ensureVideoLoadedAt(index);
        if (index + 1 < blockDataMap.length) ensureVideoLoadedAt(index + 1);
        if (index - 1 >= 0) ensureVideoLoadedAt(index - 1);
      }
      function unloadFarSlides(centerIndex, keepRadius = 2) {
        if (!mobileVideoWrapper) return;
        mobileVideoWrapper.querySelectorAll(".swiper-slide").forEach((slide) => {
          const idx = parseInt(slide.dataset.vcIndex, 10);
          const video = slide.querySelector("video");
          if (!video) return;
          if (Math.abs(idx - centerIndex) > keepRadius) {
            if (video.dataset.loaded === "1") {
              try {
                video.pause();
                video.removeAttribute("src");
                video.load();
                video.dataset.loaded = "0";
                console.log("[VC] unloaded video at", idx);
              } catch (e) { /* ignore */ }
            }
          }
        });
      }

      // Progress loop
      function startProgressLoopFor(video) {
        stopProgressLoop();
        activeVideo = video;
        function step() {
          try {
            if (activeVideo && activeVideo.duration && activeVideo.duration > 0) {
              const pct = Math.max(0, Math.min(1, activeVideo.currentTime / activeVideo.duration));
              if (isMobile && mobileProgressEl) mobileProgressEl.style.width = pct * 100 + "%";
              if (!isMobile && desktopProgressEl) desktopProgressEl.style.width = pct * 100 + "%";
            } else {
              if (isMobile && mobileProgressEl) mobileProgressEl.style.width = "0%";
              if (!isMobile && desktopProgressEl) desktopProgressEl.style.width = "0%";
            }
          } catch (err) {
            console.warn("[VC] progress loop error", err);
          }
          rafId = requestAnimationFrame(step);
        }
        rafId = requestAnimationFrame(step);
      }
      function stopProgressLoop() { if (rafId) cancelAnimationFrame(rafId); rafId = null; }

      // UI binders
      function bindVideoUI(video) {
        if (!video) return;
        if (video.dataset.vcBound === "1") return;
        video.dataset.vcBound = "1";
        video.addEventListener("play", () => {
          setPlayUi(true);
          startProgressLoopFor(video);
        });
        video.addEventListener("pause", () => {
          setPlayUi(false);
        });
        video.addEventListener("ended", () => {
          setPlayUi(false);
        });
        video.addEventListener("volumechange", () => {
          setMuteUi(video.muted);
        });
      }
      function setPlayUi(isPlaying) {
        document.querySelectorAll("#pause-icon").forEach((el) => (el.style.display = isPlaying ? "block" : "none"));
        document.querySelectorAll("#play-icon").forEach((el) => (el.style.display = isPlaying ? "none" : "block"));
        document.querySelectorAll("#play-label").forEach((el) => (el.textContent = isPlaying ? "Pause" : "Play"));
      }
      function setMuteUi(isMuted) {
        document.querySelectorAll(".mute-off").forEach((el) => (el.style.display = isMuted ? "none" : "block"));
        document.querySelectorAll(".mute-cross").forEach((el) => (el.style.display = isMuted ? "block" : "none"));
        document.querySelectorAll("#mute-label").forEach((el) => (el.textContent = isMuted ? "Sound off" : "Sound on"));
      }

      // play mobile video at index
      function playMobileVideoAt(index, opts = { autoplay: false }) {
        if (!mobileVideoWrapper) return;
        const slide = mobileVideoWrapper.querySelector(`.swiper-slide[data-vc-index="${index}"]`);
        if (!slide) { console.warn("[VC] playMobileVideoAt: slide not found", index); return; }
        const video = slide.querySelector("video");
        if (!video) { console.warn("[VC] playMobileVideoAt: video element missing", index); return; }

        ensureVideoLoadedAt(index);
        bindVideoUI(video);

        mobileVideoWrapper.querySelectorAll("video").forEach((v) => {
          if (v === video) return;
          try { if (!v.paused) v.pause(); v.classList.remove("playing"); } catch (e) {}
        });

        // Keep muted for autoplay policy — user can toggle later
        video.muted = true;
        if (opts.autoplay) {
          video.play().then(() => {
            video.classList.add("playing");
            setPlayUi(true);
            setMuteUi(video.muted);
          }).catch((err) => {
            console.warn("[VC] mobile autoplay rejected", err);
            setPlayUi(false);
          });
        } else {
          bindVideoUI(video);
        }

        preloadNeighbors(index);
        unloadFarSlides(index, 2);
        activeVideo = video;
      }

      // Desktop open
      function openDesktopLightbox(index) {
        if (!lightboxVideo) { console.warn("[VC] desktop lightbox video missing"); return; }
        index = Math.max(0, Math.min(index, blockDataMap.length - 1));
        try {
          lightboxVideo.pause();
          lightboxVideo.muted = false;
          lightboxVideo.src = blockDataMap[index].videoSrc || "";
          lightboxVideo.setAttribute("preload", "auto");
          lightboxVideo.load();
          bindVideoUI(lightboxVideo);
          lightboxVideo.play().then(() => {
            setMuteUi(lightboxVideo.muted);
            console.log("[VC] desktop lightbox playing", index);
          }).catch((err) => console.warn("[VC] desktop play() rejected", err));
          updateProductContent(index);
          if (videoLightbox) { videoLightbox.classList.add("active"); document.body.style.overflow = "hidden"; }
          activeVideo = lightboxVideo;
          startProgressLoopFor(activeVideo);
        } catch (err) {
          console.warn("[VC] openDesktopLightbox error", err);
        }
      }

      // update product HTML inside lightbox/drawer
      function updateProductContent(idx) {
        if (!blockDataMap.length) return;
        idx = Math.max(0, Math.min(idx, blockDataMap.length - 1));
        const html = blockDataMap[idx].productHTML || "";
        if (lightboxProductsGrid) lightboxProductsGrid.innerHTML = html;
        if (drawerProductsGrid) drawerProductsGrid.innerHTML = html;
      }

      // init mobile swiper
      function initMobileSwiper(startIndex = 0) {
        if (!mobileContainer || mobileVideoSwiper || typeof Swiper === "undefined") return;
        try {
          mobileVideoSwiper = new Swiper(".mobile-video-swiper-container", {
            direction: "vertical",
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 300,
            resistanceRatio: 0,
            longSwipes: false,
            threshold: 8,
            touchRatio: 1,
            slideToClickedSlide: false,
            loop: true,
            initialSlide: startIndex,
            watchOverflow: true,
            allowTouchMove: true,
            simulateTouch: true,
            preventClicks: false,
            preventClicksPropagation: false,
            on: {
              init: function () {
                preloadNeighbors(startIndex);
                playMobileVideoAt(startIndex, { autoplay: true });
              },
              slideChange: function () {
                const idx = this.activeIndex || 0;
                currentIndex = idx;
                updateProductContent(idx);
                preloadNeighbors(idx);
                playMobileVideoAt(idx, { autoplay: true });
                unloadFarSlides(idx, 2);
              },
            },
          });
          sizeMobileSlides();
        } catch (err) {
          console.warn("[VC] mobileSwiper init error", err);
        }
      }

      // delegated click handling — includes improved add-to-cart flow
      document.addEventListener("click", async function (e) {
        try {
          const slideClicked = e.target.closest(".video-item");
          if (slideClicked) {
            e.preventDefault();
            const idx = getIndexFromTrigger(slideClicked);
            // Mobile open
            if (isMobile && mobileContainer) {
              prepareMobileSlidesLazy();
              if (videoLightbox) { videoLightbox.classList.add("active"); document.body.style.overflow = "hidden"; }
              initMobileSwiper(idx);
              if (mobileVideoSwiper && typeof mobileVideoSwiper.slideTo === "function") {
                mobileVideoSwiper.slideTo(idx, 0);
                setTimeout(() => { preloadNeighbors(idx); playMobileVideoAt(idx, { autoplay: true }); }, 60);
              } else {
                preloadNeighbors(idx); playMobileVideoAt(idx, { autoplay: true });
              }
            } else {
              openDesktopLightbox(idx);
            }
            return;
          }

          // lightbox close
          if (e.target.closest(".lightbox-close")) { closeLightbox(); return; }
          if (e.target.closest(".reelrushatc")) {
    setTimeout(() => {
        closeLightbox();
    }, 1500); // 2000 milliseconds = 2 seconds

    return; 
}
          if (e.target.closest(".lightbox-next")) { openNext(); return; }
          if (e.target.closest(".lightbox-prev")) { openPrev(); return; }

          // play/pause toggle
          if (e.target.closest(".play-pause")) {
            const v = activeVideo || (isMobile ? (mobileVideoWrapper && mobileVideoWrapper.querySelector("video.playing")) : lightboxVideo);
            if (!v) { console.warn("[VC] play-pause clicked but no active video"); return; }
            if (v.paused) v.play().catch((err) => console.warn("[VC] play() failed", err));
            else v.pause();
            return;
          }

          // mute toggle
          if (e.target.closest(".mute-toggle")) {
            const v = activeVideo || (isMobile ? (mobileVideoWrapper && mobileVideoWrapper.querySelector("video.playing")) : lightboxVideo);
            if (!v) { console.warn("[VC] mute clicked but no active video"); return; }
            v.muted = !v.muted;
            setMuteUi(v.muted);
            console.log("[VC] mute toggled ->", v.muted);
            return;
          }

          // ADD TO CART — centralized, robust flow
          const atc = e.target.closest(".spc-add-to-cart, .mpc-add-to-cart");
          if (atc) {
            e.preventDefault();
            const variantId = atc.getAttribute("data-variant-id") || atc.dataset.variantId;
            if (!variantId) {
              console.warn("[VC] add-to-cart missing variant id");
              return;
            }

            try {
              console.log("[VC] add to cart ->", variantId);
              const addRes = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: variantId, quantity: 1 }),
                credentials: "same-origin",
              });
              if (!addRes.ok) throw new Error("Add to cart failed");
              const addData = await addRes.json();
              console.log("[VC] add success", addData);

              // Show notification (existing element)
              if (cartNotification) {
                cartNotification.classList.add("show");
                setTimeout(() => cartNotification.classList.remove("show"), 2000);
              }

              // Update cart-count using authoritative source
              const cart = await updateCartCountFromServer();

              // Try to refresh the cart drawer (best-effort)
              const refreshed = await refreshCartDrawer(cart);
              if (!refreshed) {
                // fallback: if drawer exists, attempt a naive partial update:
                const drawerEl = detectDrawerContainer();
                if (drawerEl) {
                  // If theme exposes a quick cart endpoint, a best-effort is to request the main page section
                  try {
                    const frag = await fetch("/?section_id=quick-cart", { credentials: "same-origin" });
                    if (frag && frag.ok) {
                      const html = await frag.text();
                      if (html && html.length > 50) {
                        replaceDrawerHtml(drawerEl, html);
                        openDrawerUI(drawerEl);
                      }
                    }
                  } catch (err) { /* ignore */ }
                }
              }

              // dispatch legacy and app events
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
              document.dispatchEvent(new CustomEvent("apps:product-added-to-cart", { detail: addData }));

            } catch (err) {
              console.error("[VC] add-to-cart error", err);
            }
            return;
          }
        } catch (err) {
          console.error("[VC] delegated click error", err);
        }
      });

      // Utility: find index from carousel trigger
      const triggerEls = Array.from(document.querySelectorAll(".video-item"));
      function getIndexFromTrigger(el) {
        if (!el) return 0;
        const slide = el.closest(".video-item") || el;
        const dataIndex = slide.getAttribute("data-video-index") || slide.dataset.videoIndex;
        if (typeof dataIndex !== "undefined" && dataIndex !== null) {
          const pi = parseInt(dataIndex, 10);
          if (!isNaN(pi)) return pi;
        }
        const src = slide.querySelector("source")?.src || slide.querySelector("video")?.currentSrc || slide.getAttribute("data-video-src");
        if (src) {
          let idx = blockDataMap.findIndex((b) => b.videoSrc === src);
          if (idx !== -1) return idx;
          idx = blockDataMap.findIndex((b) => (src.includes(b.videoSrc) || b.videoSrc.includes(src)));
          if (idx !== -1) return idx;
        }
        const pos = triggerEls.indexOf(slide);
        if (pos !== -1 && pos < blockDataMap.length) return pos;
        const aria = slide.getAttribute("aria-label");
        if (aria) {
          const parsed = parseInt(aria.split("/")[0].trim(), 10);
          if (!isNaN(parsed)) return Math.max(0, parsed - 1);
        }
        console.warn("[VC] fallback index 0 for slide", slide);
        return 0;
      }

      function openNext() {
        const nxt = (currentIndex + 1) % blockDataMap.length;
        if (isMobile && mobileVideoSwiper) mobileVideoSwiper.slideTo(nxt, 300);
        else openDesktopLightbox(nxt);
      }
      function openPrev() {
        const prev = (currentIndex - 1 + blockDataMap.length) % blockDataMap.length;
        if (isMobile && mobileVideoSwiper) mobileVideoSwiper.slideTo(prev, 300);
        else openDesktopLightbox(prev);
      }

      function closeLightbox() {
        if (videoLightbox) videoLightbox.classList.remove("active");
        document.body.style.overflow = "";
        if (lightboxVideo) try { lightboxVideo.pause(); lightboxVideo.currentTime = 0; } catch (e) {}
        if (mobileVideoWrapper) mobileVideoWrapper.querySelectorAll("video").forEach((v) => { try { v.pause(); } catch (e) {} });
        stopProgressLoop();
        try {
          if (mobileVideoSwiper && typeof mobileVideoSwiper.destroy === "function" && !mobileVideoSwiper.destroyed) {
            mobileVideoSwiper.destroy(true, true);
            mobileVideoSwiper = null;
            console.log("[VC] mobile swiper destroyed on close");
          }
        } catch (err) { console.warn("[VC] destroy mobile swiper failed", err); }
      }

      // Initial fast preparation
      prepareMobileSlidesLazy();
      // Preload first slide metadata non-blocking
      window.requestIdleCallback ? requestIdleCallback(() => { ensureVideoLoadedAt(0); }) : setTimeout(() => ensureVideoLoadedAt(0), 300);

      // Desktop swiper init (safe)
      try {
        if (typeof Swiper !== "undefined") {
          const desktopEl = document.querySelector(".video-swiper");
          if (desktopEl) {
            new Swiper(".video-swiper", {
              slidesPerView: 2,
              spaceBetween: 10,
              loop: true,
              speed: 450,
              pagination: { el: ".swiper-pagination", clickable: true },
              navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
              breakpoints: { 768: { slidesPerView: 2 }, 1024: { slidesPerView: 5 } },
              on: { slideChangeTransitionEnd: function () { const progressEl = document.querySelector(".carousel-progress"); if (progressEl) progressEl.style.width = this.progress * 100 + "%"; } },
            });
            console.log("[VC] desktop swiper initialized");
          } else {
            console.warn("[VC] desktop swiper container not found");
          }
        } else {
          console.warn("[VC] Swiper not present — desktop carousel disabled");
        }
      } catch (err) {
        console.error("[VC] desktop swiper init error", err);
      }

      // expose debug helpers
      window.__vc = {
        prepareMobileSlidesLazy,
        ensureVideoLoadedAt,
        preloadNeighbors,
        playMobileVideoAt,
        blockDataMap,
        updateCartCountFromServer,
        refreshCartDrawer,
      };

      window.__vcInitialized = true;
      console.log("[VC] init complete — optimized + cart drawer integration enabled");
    } catch (err) {
      console.error("[VC] init error", err);
    }
  } // end onLoadOnce

  // Kick off
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // run soon
    setTimeout(onLoadOnce, 20);
  } else {
    window.addEventListener("DOMContentLoaded", onLoadOnce, { once: true });
  }
})();
